import { Box, Center, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { IMaterialIconProps, MaterialIcon } from "./MaterialIcon";

interface IProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  iconColor?: string;
}

interface IBaseProps extends IProps {
  title: string;
  iconName: IMaterialIconProps["name"];
  iconColor?: string;
}

const StatusBase = ({
  title,
  description,
  children,
  iconName,
  iconColor = "text.primary",
}: IBaseProps) => {
  return (
    <Box h="full" rounded="md" minH={"20rem"} p={8} bg="bg.main">
      <Stack h="full" spacing={6} alignItems="center">
        <Center flex={1}>
          <MaterialIcon
            color={iconColor}
            fontSize="8rem"
            name={iconName}
            variant="outline"
          />
        </Center>

        <Stack spacing="1">
          <Text fontSize="2xl" textAlign={"center"}>
            {title}
          </Text>
          {description && (
            <Text fontSize="md" textAlign={"center"} color="text.soft">
              {description}
            </Text>
          )}
        </Stack>
        {children && <Box w="full">{children}</Box>}
      </Stack>
    </Box>
  );
};

const StatusNoData = (props: IProps) => {
  const { title = "No Data", ...rest } = props;
  return <StatusBase title={title} {...rest} iconName="info"></StatusBase>;
};

const StatusNoResults = (props: IProps) => {
  const { title = "No Results", ...rest } = props;
  return (
    <StatusBase title={title} {...rest} iconName="manage_search"></StatusBase>
  );
};

const StatusIsLoading = (props: IProps) => {
  const { title = "Loading", ...rest } = props;
  return (
    <StatusBase title={title} {...rest} iconName="more_horiz"></StatusBase>
  );
};

const StatusIsError = (props: IProps) => {
  const { title = "Error", ...rest } = props;
  return (
    <StatusBase
      title={title}
      {...rest}
      iconColor={"danger"}
      iconName="error"
    ></StatusBase>
  );
};

const StatusNotFound = (props: IProps) => {
  const { title = "Not found", ...rest } = props;
  return (
    <StatusBase
      title={title}
      {...rest}
      iconColor={"warning"}
      iconName="travel_explore"
    ></StatusBase>
  );
};

export const Status = {
  IsLoading: StatusIsLoading,
  IsError: StatusIsError,
  NoData: StatusNoData,
  NotFound: StatusNotFound,
  NoResults: StatusNoResults,
};
